import React, { FunctionComponent } from 'react';
import {
  ImgTitleDescriptionComponent,
  IImgTitleDescriptionComponentProps
} from '../img-title-description/img-title-description';
import styles from './process-icons.module.scss';

export interface IProcessIconsProps {
  icons: IImgTitleDescriptionComponentProps[];
}

export const ProcessIcons: FunctionComponent<IProcessIconsProps> = ({
  icons
}) => {
  return (
    <div className={styles.wrapper}>
      {icons.map((icon, i) => (
        <div className={styles.processIcon} key={i}>
          <ImgTitleDescriptionComponent {...icon} />
          {i < icons.length - 1 && <span className={styles.separator}></span>}
        </div>
      ))}
    </div>
  );
};
